
import { EndPoints } from '../../api-config';
let SERVER_ADDR_V1 = EndPoints.backendHost;

export const postalNumberUrl = () => `${SERVER_ADDR_V1}/BackOffice/postalnumber`;

export const productsPricesUrl = () => `${SERVER_ADDR_V1}/BackOffice/products`;
export const productUrl = (productName) => `${SERVER_ADDR_V1}/BackOffice/products/${productName}`;